<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">
            {{ $route.params.id ? "Edit Reminder" : "New Reminder" }}
          </h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Form -->
    <form @submit.prevent="save">
      <div class="row">
        <div class="col-md-7" style="max-width: 850px">
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Type</label>
            <div class="col-md-10 pl-md-0">
              <select class="custom-select" v-model="type" required>
                <option value="">-- Please Select --</option>
                <option :value="reminderCarparkClaimApproval">
                  {{ reminderCarparkClaimApproval }}
                </option>
                <option :value="reminderTimesheetApproval">
                  {{ reminderTimesheetApproval }}
                </option>
                <option :value="reminderFwaApproval">
                  {{ reminderFwaApproval }}
                </option>
                <option :value="reminderFwaCancellationApproval">
                  {{ reminderFwaCancellationApproval }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Name</label>
            <div class="col-md-10 pl-md-0">
              <input
                type="text"
                class="form-control"
                v-model="name"
                maxlength="100"
                required
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Reminder Days</label>
            <div class="col-md-3 pl-md-0">
              <input
                type="number"
                class="form-control"
                v-model="reminderDays"
                step="1"
                min="1"
                max="99999"
                required
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Repeat Days</label>
            <div class="col-md-3 pl-md-0">
              <input
                type="number"
                class="form-control"
                v-model="repeatDays"
                step="1"
                min="0"
                max="99999"
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Email Subject</label>
            <div class="col-md-10 pl-md-0">
              <input
                type="text"
                class="form-control"
                v-model="emailSubject"
                maxlength="200"
                required
              />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Email Header</label>
            <div class="col-md-10 pl-md-0">
              <textarea
                class="form-control"
                rows="5"
                v-model="emailHeader"
                required
              ></textarea>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Email Footer</label>
            <div class="col-md-10 pl-md-0">
              <textarea
                class="form-control"
                rows="5"
                v-model="emailFooter"
              ></textarea>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">Web URL</label>
            <div class="col-md-10 pl-md-0">
              <textarea
                class="form-control"
                rows="3"
                v-model="webUrl"
                maxlength="1000"
              ></textarea>
            </div>
          </div>
          <div class="form-group row align-items-center">
            <label class="col-md-2 mb-0">URL</label>
            <div class="col-md-10 pl-md-0">
              <textarea
                class="form-control"
                rows="3"
                v-model="url"
                maxlength="1000"
              ></textarea>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <button
                type="button"
                class="btn btn-secondary"
                @click="$router.go(-1)"
              >
                <i class="fa fa-reply mr-2"></i>Back
              </button>
            </div>
            <div class="col-md-9 text-right">
              <button type="submit" class="btn btn-primary">
                <i v-if="$route.params.id" class="fa fa-save"></i>
                <i v-else class="fa fa-plus"></i>
                {{ $route.params.id ? "Save" : "Add" }}
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-5">
          <table v-if="type" class="table table-bordered custom-table">
            <thead class="thead-light">
              <tr>
                <th style="width: 30%">Short Code</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>[#SubmitterName#]</td>
                <td>Name of the submitter</td>
              </tr>
              <tr>
                <td>[#ApproverName#]</td>
                <td>Name of the approver</td>
              </tr>
              <template
                v-if="
                  type == reminderCarparkClaimApproval ||
                  type == reminderTimesheetApproval
                "
              >
                <tr>
                  <td>[#Month#]</td>
                  <td v-if="type == reminderCarparkClaimApproval">
                    The month of the car park claim
                  </td>
                  <td v-if="type == reminderTimesheetApproval">
                    The month of the timesheet
                  </td>
                </tr>
                <tr>
                  <td>[#Year#]</td>
                  <td v-if="type == reminderCarparkClaimApproval">
                    The year of the car park claim
                  </td>
                  <td v-if="type == reminderTimesheetApproval">
                    The year of the timesheet
                  </td>
                </tr>
              </template>
              <template
                v-if="
                  type == reminderFwaApproval ||
                  type == reminderFwaCancellationApproval
                "
              >
                <tr>
                  <td>[#StartDate#]</td>
                  <td>FWA Start Date</td>
                </tr>
                <tr>
                  <td>[#EndDate#]</td>
                  <td>FWA End Date</td>
                </tr>
              </template>
              <tr>
                <td>[#WebUrl#]</td>
                <td>The link from Web URL field</td>
              </tr>
              <tr>
                <td>[#Url#]</td>
                <td>The link from URL field</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
    <!-- /Form -->
  </div>
</template> 

<script>
import config from "../../../config.js";
import API from "../../../http-common.js";
export default {
  data() {
    return {
      reminderCarparkClaimApproval: config.REMINDER_CAR_PARK_CLAIM_APPROVAL,
      reminderTimesheetApproval: config.REMINDER_TIMESHEET_APPROVAL,
      reminderFwaApproval: config.REMINDER_FWA_APPROVAL,
      reminderFwaCancellationApproval:
        config.REMINDER_FWA_CANCELLATION_APPROVAL,
      type: "",
      name: "",
      reminderDays: "",
      repeatDays: "",
      emailSubject: "",
      emailHeader: "",
      emailFooter: "",
      webUrl: "",
      url: "",
    };
  },

  computed: {
    token() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Token;
    },
    role() {
      let data = JSON.parse(localStorage.getItem("lambitoken"));
      return data.Role;
    },
  },

  watch: {
    type(val) {
      if (!this.$route.params.id) {
        if (val == this.reminderCarparkClaimApproval) {
          this.emailSubject = "Car Park Claim Submission by [#SubmitterName#]";
          this.emailHeader =
            "Hi [#ApproverName#],\n\nThere is a car park claim submission for [#Month#]/[#Year#].\nClick <a href='[#WebUrl#]'>here</a> to login and view the car park claim to approve or reject it.";
          this.emailFooter = "Instruction link:\n[#Url#]";
        } else if (val == this.reminderTimesheetApproval) {
          this.emailSubject = "Timesheet Submission by [#SubmitterName#]";
          this.emailHeader =
            "Hi [#ApproverName#],\n\nThere is a timesheet submission for [#Month#]/[#Year#].\nClick <a href='[#WebUrl#]'>here</a> to login and view the timesheet to approve or reject it.";
          this.emailFooter = "Instruction link:\n[#Url#]";
        } else if (val == this.reminderFwaApproval) {
          this.emailSubject = "[#SubmitterName#] apply FWA for your review";
          this.emailHeader =
            "Hi [#ApproverName#],\n\nThere is a FWA submission for [#StartDate#] to [#EndDate#].\nClick <a href='[#WebUrl#]'>here</a> to login and view the FWA application to approve or reject it.";
          this.emailFooter = "Instruction link:\n[#Url#]";
        } else if (val == this.reminderFwaCancellationApproval) {
          this.emailSubject = "[#SubmitterName#] cancel FWA for your review";
          this.emailHeader =
            "Hi [#ApproverName#],\n\nThere is a FWA cancellation for [#StartDate#] to [#EndDate#].\nClick <a href='[#WebUrl#]'>here</a> to login and view the FWA cancellation to approve or reject it.";
          this.emailFooter = "Instruction link:\n[#Url#]";
        } else {
          this.emailSubject = "";
          this.emailHeader = "";
          this.emailFooter = "";
        }
      }
    },
  },

  methods: {
    getReminderDetail() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.getReminderDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            if (response.data.record) {
              let data = response.data.record;
              this.type = data.Type;
              this.name = data.Name;
              this.reminderDays = data.ReminderDays;
              this.repeatDays = data.RepeatDays;
              this.emailSubject = data.EmailSubject;
              this.emailHeader = data.EmailHeader;
              this.emailFooter = data.EmailFooter;
              this.webUrl = data.WebURL;
              this.url = data.URL;
            } else {
              this.$router.replace({ name: "reminderList" });
            }
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    save() {
      let param = {
        Token: this.token,
        Id: this.$route.params.id,
        Type: this.type,
        Name: this.name,
        ReminderDays: this.reminderDays,
        RepeatDays: this.repeatDays,
        EmailSubject: this.emailSubject,
        EmailHeader: this.emailHeader,
        EmailFooter: this.emailFooter,
        WebURL: this.webUrl,
        URL: this.url,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to save the reminder?",
        icon: "info",
        buttons: true,
        dangerMode: false,
      }).then((willSave) => {
        if (willSave) {
          this.$store.state.isLoading = true;
          API.saveReminder(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.$store.state.reminderType = this.type;
                this.$router.replace({ name: "reminderList" });
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
  },

  created() {
    this.type = this.$store.state.reminderType;
    if (this.$route.params.id) this.getReminderDetail();
    //access control
    if (this.role != "admin")
      this.$router.replace({ name: "home" });
  },
};
</script>

<style scoped>
.col-md-2 {
  max-width: 150px;
}

.table td {
  border-top: none;
}
</style>



// WEBPACK FOOTER //
// src/components/System/Reminder/ReminderEdit.vue